import Container from '../../../elements/Container'
import Section from '../../../elements/Section'
import Tabs from '../../../elements/Tabs'
import { useResponsive } from '../../../../providers/ResponsiveContext'
import BlogCard from '../../../custom/BlogCard'
import { useRef } from 'react'
import Paginate from '../../../elements/Paginate'
import { useRouter } from 'next/router'

const Content = ({ buttonLabel, blogs }) => {
  const { isMobile } = useResponsive()
  const ref = useRef(null)
  const router = useRouter()

  const localeBlogs = blogs[router.locale]
  const blogCategories =
    localeBlogs && Object.keys(localeBlogs).map((item) => item)

  const blogContent =
    blogCategories &&
    blogCategories.map((item) => {
      return {
        title: item,
        content: (
          <div>
            <Paginate
              sectionRef={ref}
              items={localeBlogs[item].map((blog, index) => (
                <BlogCard
                  buttonLabel={buttonLabel}
                  key={`blog-${index}`}
                  {...blog}
                />
              ))}
              itemsPerPage={8}
              grid={[!isMobile && 'grid-2']}
            />
          </div>
        )
      }
    })

  return (
    <Section sectionRef={ref}>
      <Container>{blogContent && <Tabs content={blogContent} />}</Container>
    </Section>
  )
}

export default Content
